import { getGiveawayFaqs, GiveawayFaq } from '../config'

export const useGiveawayFaqs = (theatricalSlug: string): GiveawayFaq[] => {
  return getGiveawayFaqs(theatricalSlug)
}
